import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";

const ShippingCost = () => {
    const [dataShippingCost, setDataShippingCost] = useState([]);

    // State variables to manage button visibility
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const [showUpdateButton, setShowUpdateButton] = useState(false);

    const [newdata, setNewdata] = useState({
        id: "", weightSlot: "", costINR: 0, costOthers: 0, createdBy: ""
    });

    const { weightSlot, costINR, costOthers } = newdata;
    let userInfo = JSON.parse(localStorage.getItem('admin-info'));

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetShippingCostDetails', setDataShippingCost);
    }, []);

    const columns = [
        {
            name: "Weight Slot",
            selector: row => row.weightSlot,
            sortable: true,
            width: "200px"
        },
        {
            name: "Cost INR",
            selector: row => row.costINR,
            sortable: true,
            width: "200px"
        },
        {
            name: "Cost Others",
            selector: row => row.costOthers,
            sortable: true,
            width: "200px"
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={(event) => onEditClick(event, row)}>
                        <img
                            src="/images/ImgEdit.ico"
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth: "200px",
        },
    ];

    const onEditClick = async (event, row) => {
        event.preventDefault();
        setNewdata({
            id: row.id,
            weightSlot: row.weightSlot,
            costINR: row.costINR,
            costOthers: row.costOthers,
            createdBy: userInfo.user_id
        });
        setShowSubmitButton(false);
        setShowUpdateButton(true);
    };

    const handleUpdate = async () => {
        try {
            const response = await fetch(`https://igapi.heuristticminds.com/api/CurrencyList/Update-UpdateShippingCost`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newdata),
            });

            if (response.ok) {
                alert("Shipping cost updated successfully");
                setNewdata({ id: "", weightSlot: "", costINR: 0, costOthers: 0 });
                setShowSubmitButton(true);
                setShowUpdateButton(false);
                fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetShippingCostDetails', setDataShippingCost);
            } else {
                console.error("Failed to update shipping cost");
            }
        } catch (error) {
            console.error("Error updating shipping cost:", error);
        }
    };

    const handleSubmit = async () => {
        const { id, ...requestData } = {
            ...newdata,
            createdBy: userInfo.user_id
        };

        try {
            const response = await fetch('https://igapi.heuristticminds.com/api/CurrencyList/Add-SaveShippingCost', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestData),
            });

            if (response.ok) {
                alert("Shipping cost added successfully");
                setNewdata({ id: "", weightSlot: "", costINR: 0, costOthers: 0 });
                fetchData('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetShippingCostDetails', setDataShippingCost);
            } else {
                console.error("Failed to add shipping cost");
            }
        } catch (error) {
            console.error("Error adding shipping cost:", error);
        }
    };

    const handleCostINRChange = (e) => {
        setNewdata({ ...newdata, costINR: e.target.value });
    };

    const handleCostOthersChange = (e) => {
        setNewdata({ ...newdata, costOthers: e.target.value });
    };

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <PageHeader name='Add/Edit Shipping Cost' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Add/Edit Shipping Cost</div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-2 form-group mb-2">
                                                <label>Weight Slot Code<span style={{ color: "#ff0000" }}>*</span></label>
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                <label>Cost in INR<span style={{ color: "#ff0000" }}>*</span></label>
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                <label>Cost in Other Currency<span style={{ color: "#ff0000" }}>*</span></label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-2 form-group mb-2">
                                                <input type="text"
                                                    name="weightSlot"
                                                    value={weightSlot}
                                                    onChange={(e) => setNewdata({ ...newdata, weightSlot: e.target.value })}
                                                    className="form-control"
                                                    maxLength={15}
                                                    placeholder="Weight Slot"
                                                />
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                <input type="text"
                                                    name="costINR"
                                                    value={costINR}
                                                    className="form-control"
                                                    maxLength={6}
                                                    placeholder="Cost INR"
                                                    onChange={handleCostINRChange} />
                                            </div>
                                            <div className="col-sm-2 form-group mb-2">
                                                <input type="text"
                                                    name="costOthers"
                                                    value={costOthers}
                                                    className="form-control"
                                                    maxLength={6}
                                                    placeholder="Cost Others"
                                                    onChange={handleCostOthersChange} />
                                            </div>
                                            <div className="col-sm-4 form-group mb-4">
                                                <button type="button" onClick={handleSubmit}
                                                    className={`btn btn-primary w-50 ${showSubmitButton ? '' : 'd-none'}`}>Submit</button>
                                                <button type="button" onClick={handleUpdate} className={`btn btn-primary w-50 ${showUpdateButton ? '' : 'd-none'}`}>Update</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="pb-2">
                                        <div className="col-sm-12">
                                            <DataTable
                                                columns={columns}
                                                data={dataShippingCost}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default ShippingCost;
